/* SY — avaliações sem app: lista (20 por vez), abas produto/loja, ordenação, filtro por nota,
   tradução/original, janela de cada avaliação e o formulário "Écrire un avis". O acervo vem do
   metafield de loja custom.avaliacoes, impresso pela seção em <script data-sy-rv-dados>. */
(() => {
  'use strict';

  const POR_PAGINA = 20;
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const CAMINHO = 'M12 1.8l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.9l-6.4 3.5L7 14.3l-5.3-5 7.2-.9z';
  const estrela = (cheia) => `<svg class="sy-star${cheia ? '' : ' sy-star--vazia'}" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${CAMINHO}" ${cheia ? 'fill="currentColor"' : 'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"'}/></svg>`;
  const estrelas = (n) => [1, 2, 3, 4, 5].map((i) => estrela(i <= n)).join('');
  const data = (ms) => {
    const d = new Date(ms);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  };
  const tamanho = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');
  const SELO = '<svg class="sy-rv__vbadge" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.5l2.6 1.9 3.2-.1 1 3 2.6 1.9-1 3 1 3-2.6 1.9-1 3-3.2-.1L12 22.5l-2.6-1.9-3.2.1-1-3-2.6-1.9 1-3-1-3 2.6-1.9 1-3 3.2.1z" fill="currentColor"/><path d="M8 12.2l2.6 2.6L16.2 9" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const INFO = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.3"/><path d="M8 7.2v4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="8" cy="5" r=".85" fill="currentColor"/></svg>';
  const SACOLA = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4.7 5.3V4a3.3 3.3 0 0 1 6.6 0v1.3H13a.7.7 0 0 1 .7.7v8a.7.7 0 0 1-.7.7H3a.7.7 0 0 1-.7-.7V6a.7.7 0 0 1 .7-.7h1.7Zm1.3 0h4V4a2 2 0 0 0-4 0v1.3Z" fill="currentColor"/></svg>';
  const FECHAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.7 6.3 6.3 17.7M17.7 17.7 6.3 6.3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  const SETA = (volta) => `<svg viewBox="0 0 24 24" aria-hidden="true"${volta ? ' style="transform:rotate(180deg)"' : ''}><path d="M5 12h14m-6-6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const FOTOS = '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="5" width="11" height="11" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M6.5 3h9a2 2 0 0 1 2 2v9" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><path d="m3 14 3.2-3.4 2.4 2.4 1.6-1.6L13 14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  const AVISO = {
    sim: 'Cet avis a été recueilli auprès d’un client vérifié qui a acheté cet article.',
    nao: 'Cet avis a été écrit par un visiteur du site.',
  };

  const textoHtml = (r, original) => {
    if (original) return esc(r.o);
    return (r.t || []).map(([t, m]) => (m ? `<mark class="sy-rv__mark">${esc(t)}</mark>` : esc(t))).join('');
  };

  class SyReviews extends HTMLElement {
    connectedCallback() {
      const dados = this.querySelector('[data-sy-rv-dados]');
      if (!dados) return;
      this.acervo = JSON.parse(dados.textContent);
      this.produtos = JSON.parse((this.querySelector('[data-sy-rv-produtos]') || {}).textContent || '{}');
      this.loja = JSON.parse((this.querySelector('[data-sy-rv-loja]') || {}).textContent || '{}');
      this.grade = this.querySelector('[data-sy-rv-grid]');
      this.mais = this.querySelector('[data-sy-rv-mais]');
      this.estado = { aba: 'produto', ordem: 'featured', nota: 0, mostrados: POR_PAGINA };
      this.originais = new Set();

      this.observador = new IntersectionObserver((entradas) => {
        entradas.forEach((en) => {
          if (!en.isIntersecting) return;
          en.target.querySelectorAll('.sy-rv__mark').forEach((m) => m.classList.add('is-animated'));
          this.observador.unobserve(en.target);
        });
      }, { threshold: 0.3 });

      this.addEventListener('click', (e) => this.aoClicar(e));
      this.addEventListener('keydown', (e) => {
        const item = e.target.closest('.sy-rv__item');
        if (item && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); this.abrirJanela(item.dataset.id); }
      });
      document.addEventListener('click', (e) => { if (!e.target.closest('.sy-rv__header')) this.fecharPaineis(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.fecharPaineis(); });
      this.desenhar();
    }

    lista() {
      let itens = (this.acervo[this.estado.aba] || []).slice();
      if (this.estado.nota) itens = itens.filter((r) => r.r === this.estado.nota);
      const o = this.estado.ordem;
      if (o === 'newest') itens.sort((a, b) => b.d - a.d);
      else if (o === 'highest') itens.sort((a, b) => b.r - a.r || b.d - a.d);
      else if (o === 'lowest') itens.sort((a, b) => a.r - b.r || b.d - a.d);
      return itens;
    }

    cartao(r) {
      const foto = r.f && r.f.length;
      const produto = this.produtos[r.p];
      const original = this.originais.has(r.id);
      let html = `<div class="sy-rv__item-wrap${foto ? ' has-img' : ' no-img'}${this.estado.aba === 'loja' ? ' is-loja' : ''}" data-id="${esc(r.id)}">`
        + `<div class="sy-rv__item" role="button" tabindex="0" data-id="${esc(r.id)}">`;
      if (foto) {
        const [w, h, cor] = (r.fd && r.fd[0]) || [1, 1, '#eee'];
        const alt = r.pn ? `Avis photo d'un client sur ${r.pn}` : "Avis photo d'un client";
        html += `<div class="sy-rv__img"><img src="${esc(tamanho(r.f[0], 400))}" alt="${esc(alt)}" width="${w}" height="${h}" loading="lazy" style="background:${esc(cor)}">`
          + (r.f.length > 1 ? `<span class="sy-rv__multi">${FOTOS}+${r.f.length - 1}</span>` : '') + '</div>';
      }
      html += '<div class="sy-rv__main">'
        + `<div class="sy-rv__title-wrap"><div class="sy-rv__title">${esc(r.n)}${r.v ? `${SELO}<span class="sy-rv__vtexto">Vérifié</span>` : ''}</div></div>`
        + `<div class="sy-rv__time">${data(r.d)}</div>`
        + `<div class="sy-rv__stars-line"><span role="img" aria-label="${r.r} / 5">${estrelas(r.r)}</span></div>`
        + `<div class="sy-rv__text-block"><div class="sy-rv__text">${textoHtml(r, original)}</div>`;
      if (r.tr) {
        html += original
          ? `<div class="sy-rv__tr"><div class="sy-rv__tr-text"><a class="sy-rv__tr-cta" data-sy-rv-traduzir="${esc(r.id)}">${esc(r.ov || 'Afficher la traduction')}</a></div></div>`
          : `<div class="sy-rv__tr"><div class="sy-rv__tr-text">Traduit automatiquement depuis ${esc(r.tr)}. <a class="sy-rv__tr-cta" data-sy-rv-original="${esc(r.id)}">Afficher l’original</a></div></div>`;
      }
      html += '</div></div>';
      if (this.estado.aba === 'loja') {
        const logo = produto ? produto.i : this.loja.logo;
        html += `<div class="sy-rv__thumb-box" data-url="${esc(produto ? produto.u : '')}">`
          + (logo ? `<img src="${esc(logo)}" alt="${esc(r.pn || '')}" width="50" height="50" loading="lazy">` : '')
          + '<div class="sy-rv__thumb-wrap"><div class="sy-rv__thumb-label">Produit acheté</div>'
          + `<div class="sy-rv__thumb-name">${esc(r.pn || '')}</div>`
          + (r.q ? `<div class="sy-rv__thumb-quote">${esc(r.q)}</div>` : '')
          + '</div></div>';
      } else if (r.pn) {
        html += `<div class="sy-rv__product" data-url="${esc(produto ? produto.u : '')}">`
          + (produto && produto.i ? `<img src="${esc(produto.i)}" alt="${esc(r.pn)}" width="50" height="50" loading="lazy">` : '')
          + `<div class="sy-rv__pname${produto && produto.i ? ' name-with-img' : ''}">${esc(r.pn)}</div></div>`;
      }
      return `${html}</div></div>`;
    }

    desenhar() {
      const itens = this.lista();
      const visiveis = itens.slice(0, this.estado.mostrados);
      this.grade.innerHTML = visiveis.length
        ? visiveis.map((r) => this.cartao(r)).join('')
        : '<p class="sy-rv__vazio">Aucun avis pour le moment.</p>';
      this.mais.hidden = itens.length <= this.estado.mostrados;
      this.grade.querySelectorAll('.sy-rv__item-wrap').forEach((el) => this.observador.observe(el));
    }

    aoClicar(e) {
      const abrir = e.target.closest('[data-sy-rv-abrir]');
      if (abrir) { this.alternarPainel(abrir); return; }
      const ordem = e.target.closest('[data-ordem]');
      if (ordem) {
        this.estado.ordem = ordem.dataset.ordem;
        this.estado.mostrados = POR_PAGINA;
        this.querySelectorAll('[data-ordem]').forEach((b) => b.setAttribute('aria-pressed', String(b === ordem)));
        this.fecharPaineis();
        this.desenhar();
        return;
      }
      const linha = e.target.closest('.sy-rv__dist-row');
      if (linha) {
        const n = Number(linha.dataset.nota);
        this.estado.nota = this.estado.nota === n ? 0 : n;
        this.estado.mostrados = POR_PAGINA;
        this.querySelectorAll('.sy-rv__dist-row').forEach((l) => l.setAttribute('aria-pressed', String(Number(l.dataset.nota) === this.estado.nota)));
        this.fecharPaineis();
        this.desenhar();
        return;
      }
      const aba = e.target.closest('[data-aba]');
      if (aba) {
        if (aba.dataset.aba === this.estado.aba) return;
        this.estado = { aba: aba.dataset.aba, ordem: 'featured', nota: 0, mostrados: POR_PAGINA };
        this.querySelectorAll('[data-aba]').forEach((b) => {
          b.classList.toggle('is-active', b === aba);
          b.setAttribute('aria-selected', String(b === aba));
        });
        this.querySelectorAll('[data-ordem]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        this.querySelectorAll('.sy-rv__dist-row').forEach((l) => l.setAttribute('aria-pressed', 'false'));
        this.desenhar();
        return;
      }
      if (e.target.closest('[data-sy-rv-mais]')) {
        this.estado.mostrados += POR_PAGINA;
        this.desenhar();
        return;
      }
      if (e.target.closest('[data-sy-rv-escrever]')) { abrirEscrita(); return; }
      const orig = e.target.closest('[data-sy-rv-original]');
      const trad = e.target.closest('[data-sy-rv-traduzir]');
      if (orig || trad) {
        e.stopPropagation();
        const id = (orig || trad).dataset[orig ? 'syRvOriginal' : 'syRvTraduzir'];
        if (orig) this.originais.add(id); else this.originais.delete(id);
        const r = (this.acervo[this.estado.aba] || []).find((x) => x.id === id);
        const velho = this.grade.querySelector(`.sy-rv__item-wrap[data-id="${CSS.escape(id)}"]`);
        if (r && velho) velho.outerHTML = this.cartao(r);
        return;
      }
      const prod = e.target.closest('.sy-rv__product[data-url], .sy-rv__thumb-box[data-url]');
      if (prod && prod.dataset.url) { window.location.href = prod.dataset.url; return; }
      const item = e.target.closest('.sy-rv__item');
      if (item) this.abrirJanela(item.dataset.id);
    }

    alternarPainel(botao) {
      const painel = this.querySelector(`[data-sy-rv-painel="${botao.dataset.syRvAbrir}"]`);
      const abrir = painel.hidden;
      this.fecharPaineis();
      if (abrir) {
        painel.hidden = false;
        botao.setAttribute('aria-expanded', 'true');
      }
    }

    fecharPaineis() {
      this.querySelectorAll('[data-sy-rv-painel]').forEach((p) => { p.hidden = true; });
      this.querySelectorAll('[data-sy-rv-abrir]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }

    abrirJanela(id) {
      const r = (this.acervo[this.estado.aba] || []).find((x) => x.id === id);
      if (r) abrirJanela(r, this.produtos[r.p], this.originais.has(id));
    }
  }

  /* ---------------------------------------------------------------- janela da avaliação */
  let janela = null;
  let ultimoFoco = null;
  const fecharJanela = () => {
    if (!janela || janela.hidden) return;
    janela.hidden = true;
    document.documentElement.style.overflow = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  };

  function abrirJanela(r, produto, original) {
    if (!janela) {
      janela = document.createElement('sy-rv-janela');
      janela.className = 'sy sy-rv-janela';
      janela.setAttribute('role', 'dialog');
      janela.setAttribute('aria-modal', 'true');
      document.body.appendChild(janela);
      janela.addEventListener('click', (e) => {
        if (!e.target.closest('.sy-rv-j__card') || e.target.closest('[data-sy-rv-jfechar]')) { fecharJanela(); return; }
        const info = e.target.closest('[data-sy-rv-info]');
        if (info) { janela.querySelector('.sy-rv-j__aviso').classList.toggle('is-open'); return; }
        const seta = e.target.closest('[data-sy-rv-passo]');
        if (seta) { janela.irPara(janela.atual + Number(seta.dataset.syRvPasso)); return; }
        const mini = e.target.closest('[data-sy-rv-mini]');
        if (mini) janela.irPara(Number(mini.dataset.syRvMini));
      });
      document.addEventListener('keydown', (e) => {
        if (janela.hidden) return;
        if (e.key === 'Escape') fecharJanela();
        if (e.key === 'ArrowRight') janela.irPara(janela.atual + 1);
        if (e.key === 'ArrowLeft') janela.irPara(janela.atual - 1);
      });
    }
    const fotos = r.f || [];
    const dims = r.fd || [];
    const cor = (i) => esc((dims[i] || [])[2] || '#000');
    let html = '<div class="sy-rv-j__body"><div class="sy-rv-j__qv">'
      + `<div class="sy-rv-j__wrap${fotos.length ? ' has-img' : ' no-img'}"><div class="sy-rv-j__card" tabindex="-1">`;
    if (fotos.length) {
      html += `<div class="sy-rv-j__media" style="background:${cor(0)}"><div class="sy-rv-j__slider">`
        + `<div class="sy-rv-j__slides">${fotos.map((u, i) => `<div class="sy-rv-j__slide" style="background:${cor(i)}"><img src="${esc(tamanho(u, 1080))}" alt="${esc(`image ${i + 1} sur ${fotos.length}`)}" style="background:${cor(i)}"></div>`).join('')}</div>`;
      if (fotos.length > 1) {
        html += `<button type="button" class="sy-rv-j__seta sy-rv-j__seta--prev" data-sy-rv-passo="-1" aria-label="Précédent">${SETA(true)}</button>`
          + `<button type="button" class="sy-rv-j__seta sy-rv-j__seta--next" data-sy-rv-passo="1" aria-label="Suivant">${SETA(false)}</button>`
          + `<div class="sy-rv-j__thumbs-window"><div class="sy-rv-j__thumbs">${fotos.map((u, i) => `<button type="button" class="sy-rv-j__thumb" data-sy-rv-mini="${i}" aria-label="${esc(`image ${i + 1} sur ${fotos.length}`)}"><img src="${esc(tamanho(u, 120))}" alt="" style="background:${cor(i)}"></button>`).join('')}</div></div>`;
      }
      html += '</div></div>';
    }
    const texto = original ? esc(r.o) : (r.tc ? esc(r.tc) : (r.t || []).map(([t, m]) => (m ? `<mark>${esc(t)}</mark>` : esc(t))).join(''));
    html += '<div class="sy-rv-j__main"><div class="sy-rv-j__details">'
      + `<div class="sy-rv-j__row"><div class="sy-rv-j__nome">${esc(r.n)}</div><div class="sy-rv-j__info-wrap"><button type="button" class="sy-rv-j__info" data-sy-rv-info aria-label="Informations sur cet avis">${INFO}</button></div></div>`
      + `<div class="sy-rv-j__row"><div class="sy-rv-j__stars"><span role="img" aria-label="${r.r} / 5">${estrelas(r.r)}</span></div><div class="sy-rv-j__time">${data(r.d)}</div></div>`
      + `<div class="sy-rv-j__aviso">${r.v ? AVISO.sim : AVISO.nao}</div>`
      + `</div><div class="sy-rv-j__content-wrap"><div class="sy-rv-j__content"><div class="sy-rv-j__texto">${texto}</div></div></div>`;
    if (produto && produto.u) {
      html += '<div class="sy-rv-j__produto-wrap"><hr class="sy-rv-j__divider"><div class="sy-rv-j__produto">'
        + (produto.i ? `<div class="sy-rv-j__pimg"><img src="${esc(produto.i)}" alt="${esc(r.pn || produto.t)}" width="56" height="56"></div>` : '')
        + `<div class="sy-rv-j__produto-info"><div class="sy-rv-j__produto-nome">${esc(r.pn || produto.t)}</div>`
        + `<a class="sy-rv-j__ver" href="${esc(produto.u)}"><div class="sy-rv-j__ver-icon">${SACOLA}</div><span>Voir le produit</span></a></div></div></div>`;
    }
    html += `</div><button type="button" class="sy-rv-j__fechar" data-sy-rv-jfechar aria-label="Fermer"><div class="sy-rv-j__fechar-icon">${FECHAR}</div></button>`
      + '</div></div></div></div>';
    janela.innerHTML = html;
    janela.atual = 0;
    janela.irPara = (i) => {
      const total = fotos.length;
      if (!total) return;
      janela.atual = Math.max(0, Math.min(total - 1, i));
      const trilho = janela.querySelector('.sy-rv-j__slides');
      if (trilho) trilho.style.transform = `translateX(${-100 * janela.atual}%)`;
      const media = janela.querySelector('.sy-rv-j__media');
      if (media) media.style.background = (dims[janela.atual] || [])[2] || '#000';
      janela.querySelectorAll('[data-sy-rv-mini]').forEach((b, k) => b.classList.toggle('is-active', k === janela.atual));
      const prev = janela.querySelector('.sy-rv-j__seta--prev');
      const next = janela.querySelector('.sy-rv-j__seta--next');
      if (prev) prev.disabled = janela.atual === 0;
      if (next) next.disabled = janela.atual === total - 1;
    };
    janela.irPara(0);
    ultimoFoco = document.activeElement;
    janela.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const cartao = janela.querySelector('.sy-rv-j__card');
    if (cartao) cartao.focus({ preventScroll: true });
  }

  /* ---------------------------------------------------------------- escrever um avis */
  function abrirEscrita() {
    const modal = document.querySelector('[data-sy-rv-escrita]');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const campo = modal.querySelector('input:not([type="hidden"]):not([type="radio"]), textarea');
    if (campo) campo.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const x = e.target.closest('[data-sy-rv-fechar]');
    if (!x) return;
    const modal = x.closest('[data-sy-rv-escrita]');
    if (modal) { modal.hidden = true; document.documentElement.style.overflow = ''; }
  });
  document.addEventListener('keydown', (e) => {
    const modal = document.querySelector('[data-sy-rv-escrita]:not([hidden])');
    if (modal && e.key === 'Escape') { modal.hidden = true; document.documentElement.style.overflow = ''; }
  });
  // depois do envio a Shopify volta à página com ?contact_posted=true: reabre a janela com a confirmação
  if (/[?&]contact_posted=true/.test(window.location.search) || document.querySelector('[data-sy-rv-erro]')) {
    window.addEventListener('DOMContentLoaded', () => {
      if (document.querySelector('[data-sy-rv-enviado], [data-sy-rv-erro]')) abrirEscrita();
    });
  }

  if (!customElements.get('sy-reviews')) customElements.define('sy-reviews', SyReviews);
  if (!customElements.get('sy-rv-janela')) customElements.define('sy-rv-janela', class extends HTMLElement {});
  if (!customElements.get('sy-rv-modal')) customElements.define('sy-rv-modal', class extends HTMLElement {});
})();
